import { render, staticRenderFns } from "./AxTempStaffHistoryDialog.vue?vue&type=template&id=2986598c&scoped=true"
import script from "./AxTempStaffHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./AxTempStaffHistoryDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxTempStaffHistoryDialog.vue?vue&type=style&index=0&id=2986598c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986598c",
  null
  
)

export default component.exports